import React, { createContext, useEffect, useState } from "react";
import { db } from "./firebase";

const ClientContext = createContext();

const ClientProvider = ({ children }) => {
  const [client, setClient] = useState({
    sky: null,
    camera: { position: [0, 0, 0] },
  });
  const [editor, setEditor] = useState(null);
  const [camPos, setCamPos] = useState([10, 1.7, 10]);
  const [camRot, setCamRot] = useState(0);
  const [selected, setSelected] = useState(null);
  const [currentTool, setCurrentTool] = useState("scene");

  function getClient() {
    db.ref("/client").on("value", (snapshot) => {
      setClient(snapshot.val());
    });
  }

  function disconnectClient() {
    db.ref("/client").off();
    setClient(null);
  }

  function updateEditor() {
    if (!editor) {
      return;
    }
    db.ref("/editor").set(editor);
  }

  function getEditor() {
    db.ref("/editor").on("value", (snapshot) => {
      setEditor(snapshot.val());
    });
  }

  function disconnectEditor() {
    db.ref("/editor").off();
    setEditor(null);
  }

  function updateClient() {
    if (!client) {
      return;
    }
    db.ref("/client").set(client);
  }

  useEffect(() => {
    getClient();
    getEditor();

    return () => {
      disconnectClient();
      disconnectEditor();
    };
  }, []);

  useEffect(() => {
    if (
      !client ||
      !client.camera ||
      !client.camera.position ||
      !client.camera.rotation
    ) {
      return;
    }

    const [px, py, pz] = client.camera.position;
    const r = client.camera.rotation;

    setCamRot(r);

    setCamPos([px, py, pz]);
  }, [client]);

  const value = {
    client,
    setClient,
    editor,
    setEditor,
    currentTool,
    setCurrentTool,
    camPos,
    setCamPos,
    selected,
    setSelected,
    camRot,
    setCamRot,
  };

  return (
    <>
      <ClientContext.Provider value={value}>{children}</ClientContext.Provider>
    </>
  );
};

const useClient = () => {
  const context = React.useContext(ClientContext);
  if (context === undefined) {
    throw new Error("useClient must be used within a ClientProvider");
  }
  return context;
};

export { ClientContext, ClientProvider, useClient };
